// extracted by mini-css-extract-plugin
module.exports = {"image":"ResponsiveImage_image__agY9X"};